// extracted by mini-css-extract-plugin
export default {"tooltip-container":"Tooltip--tooltip-container--3QZlM","tooltipContainer":"Tooltip--tooltip-container--3QZlM","tooltip":"Tooltip--tooltip--d9Eb0","arrow":"Tooltip--arrow--f-IeC"};